import { render, staticRenderFns } from "./FitterCategories.vue?vue&type=template&id=19890164&scoped=true"
import script from "./FitterCategories.vue?vue&type=script&lang=js"
export * from "./FitterCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19890164",
  null
  
)

export default component.exports